<div class="app-container" dir="rtl">
  <header class="app-header">
    <div class="header-title">پارامترهای زنده</div>

    <button class="back-btn" onclick="window.history.back()">
      <span>بازگشت</span>
      <span class="arrow">←</span>
    </button>
  </header>

  <main class="app-content">
    <div class="cards-grid" [@cardsDeal]="menuItems.length">
      <div class="card" *ngFor="let item of menuItems">
        <div class="card-top">
          <div class="card-image-box">
            <img [src]="item.imageUrl" [alt]="item.title" class="card-image" />
          </div>
        </div>

        <div class="card-content">
          <h3 class="card-title">
            {{ item.title }}
          </h3>

          <div class="card-footer" [routerLink]="item.routerLink">
            <span class="card-action"> مشاهده اطلاعات </span>
            <span class="card-arrow"> ← </span>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
